import React, { useState } from "react";
import CompanyGrid from "./CompanyGrid";
import TransportClientsGrid from "./TransportClientsGrid";
import ServerGrid from "./ServerGrid";
import DashboardNav from "./DashboardNav";
import Titlebar from "../Titlebar";
import "./Dashboard.css";
import EWBErros from "./EWBErrors";
import RevenuesGrid from "./RevenueGrid";

export default function Dashboard({ sessionObject }) {
  const [activeTab, setActiveTab] = useState("companies");
  const [searchTerm, setSearchTerm] = useState("");

  const [transportEwbEnabled, setTransportEwbEnabled] = useState(false);
  const [revenueType, setRevenueType] = useState("transport");

  const SEARCH_PLACEHOLDERS = {
    companies: "Search by company name or GST",
    clients: "Search by company, client code or GST",
    servers: "Search by server, IP, provider or region",
    ewb_errors: "Search by company name or GST",
    revenues: "Search by company name or GST"
  };

  return (
    <>
      <Titlebar sessionObject={sessionObject} showEwbControls={false} />

      <div className="dashboard-page">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Admin Dashboard</h1>

          {(activeTab === "companies" ||
            activeTab === "clients" ||
            activeTab === "servers" ||
            activeTab === "ewb_errors" || 
            activeTab === "revenues") && (
            <input
              type="text"
              className="dashboard-search"
              placeholder={SEARCH_PLACEHOLDERS[activeTab]}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          )}
        </div>

        <DashboardNav
          active={activeTab}
          onChange={(tab) => {
            setActiveTab(tab);
            setSearchTerm("");

            if (tab !== "clients") {
              setTransportEwbEnabled(null);
            }

            if (tab === "revenues") {
              setRevenueType("transport");
            }
          }}
          transportEwbEnabled={transportEwbEnabled}
          onTransportEwbChange={setTransportEwbEnabled}
          revenueType={revenueType}
          onRevenueTypeChange={setRevenueType}
        />

        {activeTab === "companies" && (
          <CompanyGrid searchTerm={searchTerm} />
        )}

        {activeTab === "clients" && (
          <TransportClientsGrid
            searchTerm={searchTerm}
            transportEwbEnabled={transportEwbEnabled}
          />
        )}

        {activeTab === "servers" && (
          <ServerGrid searchTerm={searchTerm} />
        )}

        {activeTab === "ewb_errors" && (
          <EWBErros searchTerm={searchTerm} />
        )}

        {activeTab === "revenues" && (
          <RevenuesGrid
            revenueType={revenueType}
            searchTerm={searchTerm}
          />
        )}

      </div>
    </>
  );
}
